const Point = () => import('@/views/main/live/point/Point.vue')
export default {
  path: '/main/live/point',
  name: 'Point',
  component: Point,
  children: []
}
